// app/javascript/controllers/auth_toggle_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["login","signup","loginHeader","signupHeader","loginFooter","signupFooter"];

    connect() {
        if (!this.hasLoginTarget || !this.hasSignupTarget) return; // no-op when used outside modal
        this.showLogin();
    }

    showLogin(event) {
        if (event) event.preventDefault();
        if (!this.hasLoginTarget || !this.hasSignupTarget) return;

        this.loginTarget.classList.remove("d-none");
        this.signupTarget.classList.add("d-none");

        if (this.hasLoginHeaderTarget)  this.loginHeaderTarget.classList.remove("d-none");
        if (this.hasSignupHeaderTarget) this.signupHeaderTarget.classList.add("d-none");

        if (this.hasLoginFooterTarget)  this.loginFooterTarget.classList.remove("d-none");
        if (this.hasSignupFooterTarget) this.signupFooterTarget.classList.add("d-none");
    }

    showSignup(event) {
        if (event) event.preventDefault();
        if (!this.hasLoginTarget || !this.hasSignupTarget) return;

        this.signupTarget.classList.remove("d-none");
        this.loginTarget.classList.add("d-none");

        if (this.hasSignupHeaderTarget) this.signupHeaderTarget.classList.remove("d-none");
        if (this.hasLoginHeaderTarget)  this.loginHeaderTarget.classList.add("d-none");

        if (this.hasSignupFooterTarget) this.signupFooterTarget.classList.remove("d-none");
        if (this.hasLoginFooterTarget)  this.loginFooterTarget.classList.add("d-none");
    }
}